import { useContext } from 'react';
import { BrandInfoContext } from '@core-ui/brand-info-provider';
import useEnabledFeature from '../../useEnabledFeature';
import ABSegmentContext from '../../../components/ab-segment-context';

const useQuickFilter = (): boolean => {
  const { abbrBrand } = useContext(BrandInfoContext);
  const quickFilterFeatureEnabled = useEnabledFeature('cat-quick-filter');

  const segments = useContext(ABSegmentContext);
  const quickFilterExperimentEnabled =
    segments[`${abbrBrand}112`] === 'a' || segments[`${abbrBrand}112`] === 'b';

  return quickFilterFeatureEnabled && quickFilterExperimentEnabled;
};

export default useQuickFilter;
